import {
  CATEGORY_PARENT_URL,
  CATEGORY_URL,
  fetcher,
  fetchWithAuth,
} from "./const.routes.ts";

import useSWR from "swr";
import { ROOT_SLUG } from "../const/enviroment";

import { fetchHandler } from "./fetch";
import { ERROR, ErrorType } from "../types/Error/Errors.ts";
import {
  CategoryPostType,
  CategoryPutType,
  CategoryType,
} from "../types/Category.ts";
import { Result } from "../types/Result.ts";

export function useCategory(slug: string, fallback: CategoryType) {
  const { data, error, isLoading } = useSWR<CategoryType, ErrorType>(
    CATEGORY_URL + slug,
    fetcher,
    {
      keepPreviousData: true,
      revalidateIfStale: false,
    },
  );
  return {
    category: data ? data : fallback,
    isLoading,
    isError: error && ERROR.CATEGORY_NOT_FOUND,
  };
}

export function useCategories(fallback: string[]) {
  const { data, error, isLoading } = useSWR<string[], Error>(
    CATEGORY_URL,
    fetcher,
  );
  return {
    categories: data ? data : fallback,
    isLoading,
    isError: error && ERROR.CATEGORIES_NOT_FOUND,
  };
}

export function useCategoryParent(slug: string, fallback: CategoryType) {
  if (slug === ROOT_SLUG) {
    return {
      category: fallback,
      isLoading: false,
      isError: new Error("Root has no parent."),
    };
  }
  const { data, error, isLoading } = useSWR<CategoryType, Error>(
    CATEGORY_PARENT_URL + slug,
    fetcher,
    {
      keepPreviousData: true,
      revalidateIfStale: false,
    },
  );
  return {
    category: data ? data : fallback,
    isLoading,
    isError: error,
  };
}

export async function postCategory(
  category: CategoryPostType,
): Promise<Result<CategoryType, ErrorType>> {
  return await fetchHandler(
    fetchWithAuth(CATEGORY_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(category),
    }),
  );
}

export async function putCategory(
  category: CategoryPutType,
): Promise<Result<CategoryType, ErrorType>> {
  return await fetchHandler(
    fetchWithAuth(CATEGORY_URL, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(category),
    }),
  );
}
